import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/link.js")